import { render } from "./WagerRewardsDialog.vue?vue&type=template&id=90f90bc8"
import script from "./WagerRewardsDialog.vue?vue&type=script&lang=js"
export * from "./WagerRewardsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__